import styled from 'styled-components';
import InscriptionImage from '../../../../assets/images/inscriptions1.png';

export const BetaContainer = styled.section`
	${props => props.theme.breakpoints.up('xs')} {
		background-image: linear-gradient(338deg, #ffffff 59%, #eaeaea 75%);
	}
	${props => props.theme.breakpoints.up('sm')} {
		background-image: linear-gradient(305deg, #ffffff 28%, #eaeaea 50%);
	}

	.MuiToolbar-root {
		.MuiButton-label {
			color: ${props => props.theme.label.color};
		}
	}
`;

export const DataContainer = styled.article`
	${props => props.theme.breakpoints.up('xs')} {
		padding: 22% 8% 15% 8%;

		.beta__data-titles {
			text-align: center;
			padding: 0px;
		}
	}

	${props => props.theme.breakpoints.up('sm')} {
		padding: 17% 5% 5% 5%;
	}

	${props => props.theme.breakpoints.up('sm')} {
		padding: 8% 3.5% 18% 11%;
		.beta__data-titles {
			text-align: left;
			h2 {
				margin-left: -4px;
			}
		}
	}

	.inscriptions__image {
		width: 100%;
		background-image: url(${InscriptionImage});
		background-repeat: no-repeat;
		background-position: center;
		background-size: contain;

		${props => props.theme.breakpoints.up('xs')} {
			height: 200px;
		}

		${props => props.theme.breakpoints.up('sm')} {
			height: 300px;
		}
		${props => props.theme.breakpoints.up('md')} {
			height: 350px;
		}
	}

	.beta__image {
		${props => props.theme.breakpoints.up('xs')} {
			order: 1;
		}
		${props => props.theme.breakpoints.up('sm')} {
			order: 2;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.beta__data {
		${props => props.theme.breakpoints.up('xs')} {
			order: 2;
		}
		${props => props.theme.breakpoints.up('sm')} {
			order: 1;
			padding-right: 3%;
		}

		p {
			color: #515151;
		}

		.paragraph-dark {
			color: ${props => props.theme.palette.primary.main};
			font-weight: 900;
		}
		.span-dark {
			font-weight: 900;
		}
	}
`;
